// Tiny className-merge helper. Keeps component variant code readable
// without pulling clsx/tailwind-merge until we actually need conflict
// resolution.
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ")
}
